.publicationSection {
  padding-inline: 2rem;
}

.heading {
  margin-bottom: 20px;
  color: var(--secondary-color);
}

.cardsContainer {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(230px, 1fr));
  grid-gap: 20px;
  font-family: "Nunito Variable", sans-serif;
}

.link {
  display: inline-block;
  border-radius: 10px;
  border: 1px solid var(--secondary-color);
  padding: 70px;
  width: 100%;
  text-align: center;
  color: var(--secondary-color);
}

.publicationSection svg {
  width: 100px;
  height: auto;
}

/* Tablet */
@media (min-width: 768px) {
  .heading {
    padding-bottom: 17px;
  }
  .cardsContainer {
    grid-gap: 30px;
  }
  .link h3 {
    padding-top: 15px;
  }
}

/* Desktop */
@media (min-width: 1024px) {
  .publicationSection {
    padding: 3rem 5rem;
  }
}

/* Enable hover only on non-touch devices */
@media (hover: hover) and (pointer: fine) {
  .link:hover {
    background-color: rgba(255, 255, 255, 0.07);
  }
}
